import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const CONSULTATION_URL = 'https://myriadsystems.ai/contact';

const SupportEmptyState = ({ suggestMedbill = true, suggestVom = true }) => {
  return (
    <div className="flex flex-col items-center justify-center py-10">
      <Icon icon="no-groups" />
      <h3 className="mt-4 text-base font-semibold text-neutral-900">
        Your Myriad team has not been assigned yet
      </h3>
      {(suggestMedbill || suggestVom) && (
        <>
          <p className="mt-2 max-w-md text-center text-sm text-neutral-600">
            To maximize efficiency, you can request:
          </p>
          {suggestMedbill && (
            <p className="max-w-md text-center text-sm text-neutral-600">
              - MedBill&#39;s Built-in Biller Service to simplify billing operations
              {suggestVom ? ',' : '.'}
            </p>
          )}
          {suggestVom && (
            <p className="max-w-md text-center text-sm text-neutral-600">
              - The Virtual Office Manager Service to strengthen your front-office workflows.
            </p>
          )}
        </>
      )}
      <div className="mt-4">
        <Button
          variant="link"
          text="Submit a consultation request"
          icon="send-2-filled"
          onClick={() => window.open(CONSULTATION_URL, '_blank', 'noopener,noreferrer')}
        />
      </div>
    </div>
  );
};

export default SupportEmptyState;
